/* tslint:disable */
/* eslint-disable */
//  This file was generated from apps/appsync-bff/appsync/resources/schema.graphql
//  and should not be edited manually.

export const userAuthorizations = /* GraphQL */ `
  query LookupUserAuthorizations($userAuthorizations: [UserAuthorizationInput!]!) {
    userAuthorizations(userAuthorizations: $userAuthorizations) {
      action
      resourceType
      resourceIdentifier
      allowed
    }
  }
`;
